export default "__VITE_ASSET__Cu4anphV__"